import { IRootState } from '../../app/store';

export const selectTypeOfContentForClientAsyncStatus = (state: IRootState) =>
    state.homeContent.typeofContentExistAsyncStatus;
export const selectTypeOfContentForClient = (state: IRootState) =>
    state.homeContent.typeOfContentExist;
